import { render, staticRenderFns } from "./taxonomy-filter.vue?vue&type=template&id=eca07316"
import script from "./taxonomy-filter.ts?vue&type=script&lang=ts&external"
export * from "./taxonomy-filter.ts?vue&type=script&lang=ts&external"
import style0 from "./taxonomy-filter.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports